import React from 'react';
import { css } from '@emotion/core';
import {
	ArrowIconLight,
	Css,
	Responsive,
	StyledIconLink,
	StyledLinkText,
	VisuallyHidden,
} from '@/ui';
import styled from '@emotion/styled';
import { BaseCell, BaseHeader } from './Column';
import { IEnrichedFlight } from '../../../../shared/flight/domain/models/IEnrichedFlight';
import { useFlightDetailUrl } from '../../../../detail/ui/helpers/useFlightDetailUrl';
import { ArrowLinkStyles } from '../../../../../../components/common/button/ArrowLinkStyles';
import { Color } from '../../../../../../styles/Color';
import { RouterLink } from '../../../../../../components/common/link/RouterLink';

interface IProps {
	flight: IEnrichedFlight;
}

const styles = css`
	display: flex;
	max-width: 88px;
	text-align: right;
	${StyledIconLink} {
		white-space: nowrap;

		${StyledLinkText} {
			text-overflow: initial;
			overflow: initial;
		}
	}

	@media (${Responsive.getMediaQueryForBreakpoint('mobileXL')}) {
		max-width: 65px;
		margin-top: ${Css.pxToRem(16)};
	}
`;

export const StyledHeader = styled(BaseHeader)`
	${styles}
`;

export const StyledCell = styled(BaseCell)`
	${styles};
	font-weight: 500;
	justify-content: flex-end;
`;

export const StyledLink = styled(RouterLink)`
	${ArrowLinkStyles};
	display: flex;
	align-items: center;
	text-decoration: none;
	padding: 0 0 0 ${Css.pxToRem(8)};
	border-radius: ${Css.pxToRem(4)};

	&:hover {
		background-color: ${Color.PrimaryBlue97};

		svg {
			transform: none;
		}
	}

	& svg {
		path {
			fill: currentColor;
		}
	}
`;

export function Header() {
	return <StyledHeader />;
}

export function Cell({ flight }: IProps) {
	const href = useFlightDetailUrl(flight);
	return (
		<StyledCell>
			<StyledLink href={href}>
				Details
				<VisuallyHidden>
					for flight {flight.codeShareFlightNumber}
				</VisuallyHidden>
				<ArrowIconLight />
			</StyledLink>
		</StyledCell>
	);
}
